export default __webpack_public_path__ + "static/logo-3d85d86d72aa163eefd6c561328e11ea.svg";